import React, { useEffect, useState } from "react";
import Navbar from "../components/helpers/Navbar";
import AddVolunteerModal from "../components/voluntari/AddVolunteerModal";
import VolunteerTable from "../components/voluntari/VolunteerTable";
import ExportButtons from "../components/voluntari/ExportButtons";
import Footer from "../components/helpers/Footer";

const API_BASE = "https://prdp-api.suport-949.workers.dev/api/voluntari";

// Token hardcodat pentru autentificare Bearer
const TOKEN = "unwantedtok";
const AUTH_HEADER = {
  Authorization: `Bearer ${TOKEN}`,
};

const Voluntari = () => {
  const [volunteers, setVolunteers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [selectedVolunteer, setSelectedVolunteer] = useState(null);

  useEffect(() => {
    const fetchVolunteers = async () => {
      setLoading(true);
      try {
        const response = await fetch(API_BASE, {
          headers: AUTH_HEADER,
        });
        if (!response.ok) throw new Error("Nu s-a putut prelua lista de voluntari");
        const data = await response.json();
        setVolunteers(data);
      } catch (error) {
        console.error("Eroare la preluarea voluntarilor:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchVolunteers();
  }, []);

  const handleVolunteer = async (volunteer) => {
    try {
      if (selectedVolunteer) {
        // Editare voluntar
        const response = await fetch(`${API_BASE}/${selectedVolunteer.id}`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            ...AUTH_HEADER,
          },
          body: JSON.stringify(volunteer),
        });
        if (response.ok) {
          setVolunteers((prev) =>
            prev.map((v) =>
              v.id === selectedVolunteer.id ? { ...volunteer, id: selectedVolunteer.id } : v
            )
          );
        }
        setSelectedVolunteer(null);
        setShowModal(false);
      } else {
        // Adăugare voluntar nou
        const response = await fetch(API_BASE, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            ...AUTH_HEADER,
          },
          body: JSON.stringify(volunteer),
        });
        if (response.ok) {
          const added = await response.json();
          setVolunteers((prev) => [...prev, added]);
          setShowModal(false);
        }
      }
    } catch (error) {
      console.error("Eroare la salvare:", error);
    }
  };

  const deleteVolunteer = async (id) => {
    try {
      const response = await fetch(`${API_BASE}/${id}`, {
        method: "DELETE",
        headers: AUTH_HEADER,
      });
      if (response.ok) {
        setVolunteers((prev) => prev.filter((v) => v.id !== id));
      }
    } catch (error) {
      console.error("Eroare la ștergere:", error);
    }
  };

  const handleEdit = (volunteer) => {
    setSelectedVolunteer(volunteer);
    setShowModal(true);
  };

  const handleHideModal = () => {
    setShowModal(false);
    setSelectedVolunteer(null);
  };

  return (
    <div>
      <Navbar />
      <div className="container py-5">
        <h2 className="mb-4 text-center text-primary-dark">Listă Voluntari</h2>
        <button
          className="btn btn-primary btn-primary-admin mb-3"
          onClick={() => {
            setSelectedVolunteer(null);
            setShowModal(true);
          }}
        >
          Adaugă Voluntar
        </button>
        {loading ? (
          <div className="text-center">Se încarcă...</div>
        ) : (
          <>
            <VolunteerTable
              volunteers={volunteers}
              onDelete={deleteVolunteer}
              onEdit={handleEdit}
            />
            <ExportButtons data={volunteers} />
          </>
        )}
        <AddVolunteerModal
          show={showModal}
          onHide={handleHideModal}
          onSave={handleVolunteer}
          initialData={selectedVolunteer}
        />
        <Footer />
      </div>
    </div>
  );
};

export default Voluntari;
